var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.74 3.48h4.14a3.06 3.06 0 0 1 3.12 3V18.5c0 1.66-1.4 3-3.12 3H15.5m0 0H6.12a3.06 3.06 0 0 1-3.12-3v-.2l.04-11.54V5.5c0-1.66 1.4-3 3.13-3h6.6m2.73 19a3.06 3.06 0 0 0 3.12-3V8.39m-8.98 5.6h5.6m3.38-5.6h-4.5c-.75 0-1.36-.59-1.36-1.3V2.5m5.86 5.89L12.76 2.5M10.46 6H6h2.17v5m1.46 5.89h5.48m-8.4-2.9h.53m-.53 2.9h.53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.ef8fbde2e946158991b1306b0bac161e.svg";
export { ForwardRef as ReactComponent };